const Diff = require('diff')

window.Diff = Diff